import firebase from '@/firebase/firebase'
import Vue from 'vue'

const db = firebase.firestore()

export default {
    namespaced : true,

    state : {
        coupons : []
    },

    getters : {

    },

    actions : {
        async fetchCoupons ({ rootGetters, commit }) {
            const couponSnap = await db.collection(`/company/${rootGetters.getCompanyID}/coupons/`).get()
            const couponsArr = couponSnap.docs.map(doc => {
                const coupon = doc.data()
                const convertedDate = (coupon.expires ? coupon.expires.toDate() : '')
                return {
                    enabled : true,
                    id : doc.id,
                    description : coupon.description,
                    expires : convertedDate,
                    maxUtilizations : coupon.maxUtilizations,
                    minValue : coupon.minValue,
                    type : coupon.type,
                    utilizations : coupon.utilizations || 0,
                    value : coupon.value 
                }
            })
            commit('setCoupons', couponsArr)
        },

        async couponExists ({ rootGetters }, couponId) {
            const couponSnap = await db.collection(`/company/${rootGetters.getCompanyID}/coupons`).doc(couponId).get()
            if(couponSnap.exists)
                return 'Já existe um cupom com este nome.'
        },

        addCoupon ({ state, commit }, coupon) {
            const foundIndex = state.coupons.findIndex(a => a.id == coupon.id)
            if(foundIndex >= 0) 
                commit('updateCoupon', { coupon : coupon, index : foundIndex })
            else
                commit('setCoupon', coupon)
        },

        async removeCoupons ({ state, commit, rootGetters }, couponsIds) {
            const batch = db.batch()
            await new Promise(resolve => {
                let i = 0;
                couponsIds.forEach(coupon => {
                    const deleteSnap = db.collection(`/company/${rootGetters.getCompanyID}/coupons/`).doc(coupon)
                    batch.delete(deleteSnap)
                    i++;
                })
                if(i >= couponsIds.length)
                    resolve(true)
            })
            
            await batch.commit()
            couponsIds.forEach(coupon => {
                const couponIndex = state.coupons.findIndex(a => a.id == coupon)
                commit('deleteCoupon', couponIndex)
            })
        }
    },

    mutations : {
        deleteCoupon (state, couponIndex) {
            Vue.delete(state.coupons, couponIndex)
        },

        updateCoupon (state, { coupon, index }) {
            Vue.set(state.coupons, index, coupon)
        },

        setCoupon (state, coupon) {
            state.coupons.push(coupon)
        },

        setCoupons (state, coupons) {
            state.coupons = coupons
        }
    }
}